import { DraggableSyntheticListeners } from "@dnd-kit/core";
import { createContext, useContext } from "react";

export interface IDraggableActivatorContext {
  listeners: DraggableSyntheticListeners | undefined;
  setActivatorNodeRef: (element: HTMLElement | null) => void;
}

export const DraggableActivatorContext =
  createContext<IDraggableActivatorContext | null>(null);

export const useDraggableActivator = (): IDraggableActivatorContext => {
  const context = useContext(DraggableActivatorContext);

  if (!context) {
    throw new Error(
      "useDraggableActivator must be used within DraggableWrapper with isListeners={false}",
    );
  }

  return context;
};
